import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admission-overview',
  templateUrl: './admission-overview.component.html',
  styleUrls: ['./admission-overview.component.scss']
})
export class AdmissionOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
